module.exports = __webpack_public_path__ + "img/corona_utility.a74277aa.jpg";